import { useState , useEffect } from 'react'
import styles from './styles.module.sass'


const Review =(props) => {
    const {
        setToggleReviews,
        resetFilters
    } = props

    const [ attribute , setAttribute ] = useState(null)
    const [ toggle , setToggle ] = useState(false)
    
    const handleToggle = () => {
        setToggle(!toggle)
    }

    useEffect(()=>{
        if(resetFilters){
            setToggle(false)
            setAttribute(false)
        }
    },[resetFilters])
    
    useEffect(()=>{
        if(toggle){
            setAttribute(5)
            setToggleReviews(true)
        }else{
            setAttribute(4)
            setToggleReviews(false)
        }
    },[toggle])
    

    return(
        <div className={styles?.seccionEstrellas}>
            <div className={styles?.cajaEstrellas}>
                <div className={styles?.estrellas}>
                    <span className="fa fa-star" />
                    <span className="fa fa-star" />
                    <span className="fa fa-star" />
                    <span className="fa fa-star" />
                    <p>o más</p>
                </div>
                <div className={styles?.cajaSwitch}>
                    <label htmlFor="reviews">
                        <input
                            className={styles?.input}
                            type="checkbox"
                            checked={attribute === 5}
                            onChange={ handleToggle }
                            id="reviews"
                        />
                        <div className={styles?.toggle}>
                            <span className={styles?.selector} />
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
}

export default Review